import { Flex } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";

import { ReactComponent as EditIcon } from "images/editIcon.svg";
import { EditFeeModal } from "./EditFeeModal";
import { MODE_TYPE } from "interfaces";

interface IProps {
  text?: string;
}

export const EditFeeButton = observer((props: IProps) => {
  const { actionModals } = useStores();
  const { text } = props;

  const editFeeHandler = () => {
    actionModals.open(() => <EditFeeModal />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: "Редактирование комиссии заявки",
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return (
    <Flex gap="small" align="center">
      {text ?? `${0 * 100} %`}
      <EditIcon className="cursor-pointer" onClick={editFeeHandler} />
    </Flex>
  );
});
